import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { UserPreferencesService } from '@b2b/common/services/userPreferences/types';
import { ACMEResponse, ContentHeaderProps, TODO, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IAngularEvent, IScope, ITimeoutService } from 'angular';
import { MembershipOfferingsCreateDetailsControllerModule } from '../details/controllers/MembershipOfferingsCreateDetailsController';

MembershipOfferingsCreateController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'ApiService',
  'NoticeFactory',
  'MembershipOfferingService',
  'HelpersService',
  'UserPreferencesService',
  'TenantService',
  'TenantData',
];

function MembershipOfferingsCreateController(
  $scope: IScope & { membershipOfferingsCreate: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  NoticeFactory: NoticeFactory,
  MembershipOfferingService: TODO,
  HelpersService: TODO,
  UserPreferencesService: UserPreferencesService,
  TenantService: TODO,
  TenantData: { data: ACMEResponse<TODO> }
) {
  const ctrl = {
    model: {} as TODO,
    priceLists: [] as TODO[],
    lifecycleRules: [] as TODO[],

    tab: 'details',
    mode: 'create',

    notice: new NoticeFactory(),

    dateFormat: UserPreferencesService.getDateFormat(),
    saveReady: MembershipOfferingService.ready,
    loadedReady: MembershipOfferingService.loaded,

    isSaving: false,
    isLoaded: false,
    isSubmitted: false,
    saveAndClose: false,

    tabErrors: {
      details: false,
      policies: false,
      lifecycle: false,
    },

    init: function () {
      if ($state.params) {
        if ($state.params.offeringId) {
          ctrl.mode = 'edit';
          ctrl.getOffering();
        } else {
          ctrl.getLifecycleRules();
        }
      }

      if (TenantData.data && TenantData.data.payload) {
        TenantService.setModel(TenantData.data.payload.list[0]);
      }

      $scope.$emit('Application::contentTitleChange', {
        title: HelpersService.cap(ctrl.mode) + ' Membership Offering',
        buttonRight: {
          permissions: ['MEMBERSHIP_CATEGORY_CREATE'],
          label: ctrl.isMode('edit') ? 'Save' : 'Create & Continue',
          action: () => {
            ctrl.complete();
          },
        },
        buttonLeft: {
          label: '< Back',
          action: () => {
            ctrl.cancel();
          },
        },
      } as ContentHeaderProps);

      MembershipOfferingService.unLoaded();

      $scope.$on('$destroy', $scope.$watchCollection('membershipOfferingsCreate.saveReady', ctrl.onSaveReady));
      $scope.$on('$destroy', $scope.$watchCollection('membershipOfferingsCreate.loadedReady', ctrl.onLoadReady));
      $scope.$on('MembershipOffering::PriceListsUpdate', ctrl.onMembershipOfferingPriceListsUpdate);
      $scope.$on('MembershipOffering::Error', ctrl.onMembershipOfferingsError);
      $scope.$on('MembershipOffering::Success', ctrl.onMembershipOfferingsSuccess);
    },

    getCategory: function () {
      ApiService.membership.categories
        .detail($state.params.categoryId)
        .then((response) => ctrl.success.getCategory(response))
        .catch((response) => ctrl.error.getCategory(response));
    },

    getLifecycleRules: function () {
      ApiService.rulesEngine.lifecycle
        .list()
        .then((response) => ctrl.success.getLifecycleRules(response))
        .catch((response) => ctrl.error.getLifecycleRules(response));
    },

    getOffering: function () {
      ApiService.membership.offerings
        .detail({
          categoryId: $state.params.categoryId,
          offeringId: $state.params.offeringId,
        })
        .then((response) => ctrl.success.getOffering(response))
        .catch((response) => ctrl.error.getOffering(response));
    },

    updateModel: function () {
      $scope.$broadcast('MembershipOfferingsCreateController::Update', {
        offering: ctrl.model,
        lifecycleRules: ctrl.lifecycleRules,
      });
    },

    hasTabErrors: function (tab) {
      return ctrl.tabErrors[tab];
    },

    isValidName: function () {
      let r = true;

      if (ctrl.isSubmitted) {
        r = ctrl.model.name && ctrl.model.name.replace(/\s/g, '').length > 0;
      }

      return r;
    },

    isValidDuration: function () {
      let r = true;
      const duration = parseInt(ctrl.model.duration, 10);

      if (ctrl.isSubmitted) {
        r = !isNaN(duration) && duration > 0;
      }

      return r;
    },

    validate: function () {
      ctrl.isSubmitted = true;

      return ctrl.isValidName();
    },

    update: function (close?: TODO) {
      // Triggers update for all views the model in MembershipOfferingService
      // Flags are set in saveReady property
      // Watcher determines when everything is ready to save
      if (!ctrl.isSaving) {
        ctrl.saveAndClose = close;
        ctrl.isSaving = true;
        $scope.$broadcast('MembershipOfferingsCreateController::Save', { save: true });
      }
    },

    create: function () {
      // Triggers create for all views and updates the model in MembershipOfferingService
      // Flags are set in saveReady property
      // Watcher determines when everything is ready to save
      if (!ctrl.isSaving) {
        $scope.$broadcast('MembershipOfferingsCreateController::Save', { create: true });
      }
    },

    save: function () {
      const offering = MembershipOfferingService.getModel();

      // Copy name from master view
      offering.name = ctrl.model.name;

      if (ctrl.validate()) {
        if (ctrl.isMode('edit')) {
          ApiService.membership.offerings
            .update(
              angular.extend(
                {
                  categoryId: $state.params.categoryId,
                  offeringId: offering.id,
                },
                offering
              )
            )
            .then((response) => ctrl.success.update(response))
            .catch((response) => ctrl.error.update(response));
        } else {
          ApiService.membership.offerings
            .create(angular.extend({ categoryId: $state.params.categoryId }, offering))
            .then((response) => ctrl.success.create(response))
            .catch((response) => ctrl.error.create(response));
        }
      }
    },

    remove: function () {
      $uibModal
        .open<TODO>({
          templateUrl: 'views/application/views/membership/offerings/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'MembershipOfferingsModalsRemoveController',
          resolve: {
            currentOffering: () => ctrl.model,
          },
        })
        .result.then(() => {
          if (ctrl.hasPriceList()) {
            ctrl.priceLists = angular.copy(MembershipOfferingService.details.priceLists);
          }
          ApiService.membership.offerings
            .remove({
              categoryId: $state.params.categoryId,
              offeringId: ctrl.model.id,
            })
            .then((response) => ctrl.success.remove(response))
            .catch((response) => ctrl.error.remove(response));
        })
        .catch(() => {
          // noop
        });
    },

    hasPriceList: function () {
      return (
        MembershipOfferingService.details.priceLists instanceof Array &&
        MembershipOfferingService.details.priceLists.length &&
        MembershipOfferingService.details.priceLists[0] &&
        MembershipOfferingService.details.priceLists[0].id
      );
    },

    cancel: function () {
      // Delete price list if in create mode
      if (ctrl.isMode('create')) {
        if (ctrl.hasPriceList()) {
          ApiService.price.lists
            .remove(MembershipOfferingService.details.priceLists[0].id)
            .then((response) => ctrl.success.cancel(response))
            .catch((response) => ctrl.error.cancel(response));
        }
      }
      $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });
    },

    complete: function () {
      if (!ctrl.isSaving && ctrl.isLoaded) {
        // Reset for onSaveReady
        MembershipOfferingService.unReady();

        if (ctrl.isMode('edit')) {
          ctrl.update();
        } else {
          ctrl.create();
        }
      }
    },

    isMode: function (mode) {
      return ctrl.mode === mode;
    },

    isTab: function (tab) {
      return ctrl.tab === tab;
    },

    getTab: function (tab) {
      ctrl.tab = tab;

      // next tick
      $timeout(() => {
        $scope.$broadcast('MembershipOfferingsCreateController::FocusTab', { tab: tab });
      }, 0);
    },

    success: {
      init: function (response) {},

      create: function (response) {
        ctrl.isSubmitted = false;
        ctrl.isSaving = false;
        // Reset for onSaveReady
        MembershipOfferingService.unReady();
        // Go to edit state
        $state.go('application.membership.offerings.edit', {
          categoryId: $state.params.categoryId,
          offeringId: response.data.payload.id,
        });

        ctrl.notice.showSuccessMessages([{ message: 'Successfully created' }], { duration: 3000 });
      },

      update: function (response) {
        ctrl.isSubmitted = false;
        ctrl.isSaving = false;
        // Cleanup rules
        // Leaving commented for now this will create rules but never actually delete them
        // MembershipOfferingService.purgeRules();
        // Reset for onSaveReady
        MembershipOfferingService.unReady();

        if (ctrl.saveAndClose) {
          ctrl.saveAndClose = false;
          $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });
        } else {
          ctrl.notice.showSuccessMessages([{ message: 'Successfully updated' }], { duration: 3000 });
        }
      },

      remove: function (response) {
        ctrl.isSubmitted = false;
        $state.go('application.membership.levels.edit', { categoryId: $state.params.categoryId });

        // Copied before removal
        if (ctrl.priceLists instanceof Array && ctrl.priceLists.length && ctrl.priceLists[0] && ctrl.priceLists[0].id) {
          ApiService.price.lists
            .remove(ctrl.priceLists[0].id)
            .then((response) => ctrl.success.cancel(response))
            .catch((response) => ctrl.error.cancel(response));
        }
      },

      cancel: function (response) {},

      getCategory: function (response) {},

      getLifecycleRules: function (response) {
        ctrl.lifecycleRules = response.data.payload;
        ctrl.updateModel();
      },

      getOffering: function (response) {
        ctrl.model = response.data.payload;
        ctrl.getLifecycleRules();
      },
    },

    error: {
      init: function (response) {},
      generic: function (response) {
        ctrl.isSubmitted = false;
        ctrl.saveAndClose = false;

        ctrl.notice.showErrorMessages([{ message: response.data.error }]);
      },
      create: function (response) {
        ctrl.error.generic(response);
        ctrl.isSaving = false;
        ctrl.isLoaded = true;
        // Reset for onSaveReady
        MembershipOfferingService.unReady();
      },
      update: function (response) {
        ctrl.error.generic(response);
        ctrl.isSaving = false;
        ctrl.isLoaded = true;
        // Reset for onSaveReady
        MembershipOfferingService.unReady();
      },
      remove: function (response) {
        ctrl.error.generic(response);
      },
      cancel: function (response) {},
      getCategory: function (response) {
        ctrl.error.generic(response);
      },
      getLifecycleRules: function (response) {
        ctrl.error.generic(response);
        ctrl.isLoaded = true;
      },
      getOffering: function (response) {
        ctrl.error.generic(response);
        ctrl.isLoaded = true;
      },
    },

    onSaveReady: function (n, o) {
      if (n.details && n.lifecycle && n.policies) {
        ctrl.notice.hideErrorMessages();
        ctrl.notice.hideSuccessMessages();
        ctrl.save();
      }
    },

    onLoadReady: function (n, o) {
      if (n.details && n.lifecycle && n.policies) {
        ctrl.isLoaded = true;
      }
    },

    onMembershipOfferingPriceListsUpdate: function (e: IAngularEvent, data: TODO) {
      // Save tangentially don't want to include this in the model
      // because we extend it later on during save
      if (ctrl.isMode('edit')) {
        ctrl.update();
      }
    },

    onMembershipOfferingsSuccess: function (e: IAngularEvent, data: TODO) {
      if (ctrl.tabErrors.hasOwnProperty(data.tab)) {
        ctrl.tabErrors[data.tab] = false;
      }
    },

    onMembershipOfferingsError: function (e: IAngularEvent, data: { tab: 'details' | 'lifecycle'; message: string }) {
      if (ctrl.tabErrors.hasOwnProperty(data.tab)) {
        // Added for UI responsiveness
        $timeout(() => {
          ctrl.isSaving = false;
        }, 300);

        ctrl.tabErrors[data.tab] = true;
        ctrl.notice.showErrorMessages([{ message: data.message }]);
      }
    },
  };

  $scope.membershipOfferingsCreate = ctrl;
  ctrl.init();
}

export const MembershipOfferingsCreateControllerModule = angular
  .module('acme.view.application.membership.offerings.create.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.membership.offering',
    'acme.common.service.userPreferences',
    'acme.common.service.tenant',
    'acme.common.factory.notice',
    'acme.view.application.membership.offerings.modals.remove.controllers',
    MembershipOfferingsCreateDetailsControllerModule,
    'acme.view.application.membership.offerings.create.policies.controllers',
    'acme.view.application.membership.offerings.create.lifecycle.controllers',
  ])
  .controller('MembershipOfferingsCreateController', MembershipOfferingsCreateController).name;
